<template>
  <table class="login-table">
    <thead>
      <tr>
        <th v-translate>Přihlašovací jméno</th>
        <th v-translate>Heslo</th>
        <th v-translate>Role</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="account in testAccounts" @click="$emit('selectAccount', account)" :key="account.username">
        <td>{{ account.login }}</td>
        <td>{{ account.password }}</td>
        <td>{{ account.role }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import testAccounts from '../testAccounts'

export default {
  name: 'login-table',
  data() {
    return {
      testAccounts
    }
  }
}
</script>
